import { Stack } from '@mui/joy';
import { camelCase, startCase, upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { QuotePartRecordType } from 'quotes/enums';
import { IQuotePart } from 'quotes/types';

interface IProps {
  quotePart: IQuotePart;
}

export const PartDescriptionTypeDiscount = ({ quotePart }: IProps) => {
  const { t } = useTranslation();

  const getDiscountNote = (quotePart: IQuotePart) => {
    const { partDiscountApplyTo, pricingGroupDiscountApplyTo, recordType } = quotePart;

    let applyTo = '';

    switch (recordType) {
      case QuotePartRecordType.PRICING_GROUP_DISCOUNT:
        applyTo = pricingGroupDiscountApplyTo;

        break;
      case QuotePartRecordType.PART_DISCOUNT:
        applyTo = partDiscountApplyTo;

        break;
      default:
        applyTo = '';

        break;
    }

    return startCase(t(`label${upperFirst(camelCase(recordType))}ApplyToNote`, { applyTo }));
  };

  return (
    <Stack>
      <TextLine text={quotePart?.discountDescription || DEFAULT_PLACEHOLDER} />

      <TextLine text={getDiscountNote(quotePart)} bold upperCase />
    </Stack>
  );
};
